const { ACTIVATED_USER, INACTIVE_USER, DELETED_INACTIVATE_USER } = require("redux/admin-constants");
import UserService from "services/admin/user.service";
import { setCommonNotification } from 'redux/common/actions';
import IntlMessages from 'helpers/IntlMessages';

export const getActiveUser = (data) => async (dispatch) => {
 
    try {
      const resultData = await UserService.getActiveUserList(data);
     
      dispatch({
        type: ACTIVATED_USER,
        payload: (resultData?.status && resultData?.data) ? resultData.data : [],
      });
  
    } catch (err) {
      console.log(err)
    }
}

export const getInActiveUser = (data) => async (dispatch) => {
  
    try {
      const resultData = await UserService.getInActiveUserList(data);
     
      dispatch({
        type: INACTIVE_USER,
        payload: (resultData?.status && resultData?.data) ? resultData.data : [],
      });
  
    } catch (err) {
      console.log(err)
    }
}

export const manageActiveUser = (data) => async (dispatch) => {
  
  try {
    const resultData = await UserService.manageActiveUser(data);

    if(resultData?.status && resultData.status===true){
      dispatch(setCommonNotification({ message:   resultData.message  , isSuccess:  1 }));


    }else{
      dispatch(setCommonNotification({ message: (resultData?.message) ? resultData.message :<IntlMessages id='popup.try-again'/>, isSuccess: 0 }));
    }
   
    dispatch({
      type: DELETED_INACTIVATE_USER,
      payload: (resultData?.status) ? data : [],
    });

  } catch (err) {
    console.log(err)
  }
}